export default {"src":"/_next/static/media/sms.3f9636e8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};